import React from "react";

export default function Spinner() {
    return (
        <div className="h-[20px] w-[20px] animate-spin ">
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 3460 3460"
                version="1.1"
                style={{
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    strokeLinejoin: "round",
                    strokeMiterlimit: 2,
                }}
            >
                <g transform="matrix(5.55556,0,0,5.55556,-492.547,63.0081)">
                    <g>
                        <g opacity="0.25">
                            <g transform="matrix(0.18,0,0,0.18,88.6585,-11.3415)">
                                <use
                                    xlinkHref="#_Image1"
                                    x="21"
                                    y="21"
                                    width="3417.36px"
                                    height="3417.36px"
                                    transform="matrix(0.999812,0,0,0.999812,0,0)"
                                />
                            </g>
                            <g transform="matrix(1.13079,0,0,1.13079,34.563,-69.5014)">
                                <path
                                    d="M323.171,64.698C467.809,64.698 585.237,182.127 585.237,326.765C585.237,471.404 467.809,588.832 323.171,588.832C178.532,588.832 61.104,471.404 61.104,326.765C61.104,182.127 178.532,64.698 323.171,64.698ZM323.171,130.215C431.65,130.215 519.721,218.286 519.721,326.765C519.721,435.244 431.65,523.315 323.171,523.315C214.692,523.315 126.621,435.244 126.621,326.765C126.621,218.286 214.692,130.215 323.171,130.215Z"
                                    style={{ fill: "white" }}
                                />
                            </g>
                        </g>
                        <g opacity="0.5">
                            <g transform="matrix(0.18,0,0,0.18,88.6585,-11.3415)">
                                <use
                                    xlinkHref="#_Image2"
                                    x="21"
                                    y="21"
                                    width="1771.03px"
                                    height="1771.03px"
                                    transform="matrix(0.999453,0,0,0.999453,0,0)"
                                />
                            </g>
                            <g transform="matrix(1.13079,0,0,1.13079,34.563,-69.5014)">
                                <path
                                    d="M323.171,64.698C178.435,64.698 61.104,182.03 61.104,326.765L126.621,326.765C126.621,218.213 214.619,130.215 323.171,130.215L323.171,64.698Z"
                                    style={{ fill: "white" }}
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    );
}
